import React, { useState } from "react";
import { createPortal } from "react-dom";

type MatchTypeOption = {
  id: string;
  label: string;
};

interface MatchTypeProps {
  isOpen: boolean;
  selectedMatchTypes?: string[];
  onClose: () => void;
  onApply: (selected: string[]) => void;
}

const matchTypeOptions: MatchTypeOption[] = [
  { id: "EXACT", label: "Exact" },
  { id: "PHRASE", label: "Phrase" },
  { id: "BROAD", label: "Broad" },
  { id: "TARGETING_EXPRESSION_PREDEFINED", label: "Targeting Expression Predefined" },
  { id: "TARGETING_EXPRESSION", label: "Targeting Expression" },
];

export const MatchTypeModal: React.FC<MatchTypeProps> = ({
  isOpen,
  onClose,
  selectedMatchTypes = [],
  onApply,
}) => {
  const [selectedTypes, setSelectedType] =
    useState<string[]>(selectedMatchTypes);

  const handleChange = (id: string) => {
    setSelectedType((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleApply = () => {
    onApply(selectedTypes);
    onClose();
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="modal fade show d-block" tabIndex={-1} role="dialog">
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ zIndex: 1050 }}
      >
        <div
          className="modal-content shadow rounded-3 border-0"
          style={{ width: "65%" }}
        >
          <div className="modal-header border-0">
            <h5 className="modal-title fw-semibold">Match Type</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {matchTypeOptions.map((type) => (
              <div className="form-check mb-3" key={type.id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={type.id}
                  checked={selectedTypes.includes(type.id)}
                  onChange={() => handleChange(type.id)}
                />
                <label className="form-check-label" htmlFor={type.id}>
                  {type.label}
                </label>
              </div>
            ))}
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={onClose}
            >
              Cancel
            </button>
            <button style={{ height: "38px" }} className="btn btn-primary px-4" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
